export default "__VITE_ASSET__CD3Mwzua__"